//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as configAction from '../action/configAction';


class Comp extends React.Component {
  componentDidMount() {
    this.props.configGet();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if ( ((new Date()) - this.props.config.datetime) > (300*1000) ) {
        this.props.configGet();
      }
    }
  }

	render() {
		return null
	}
}

const mapStateToProps = (state) => {
	return {
    config: state.config,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...configAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
